import moment from "moment";
import { contactUSkeys, TAB_KEYS, vacancyKeys, contract, aboutUSkeys } from "../config";

export const formatData = (tabKey, values, updatedValues, id) => {
  values =
    values?.length > 0
      ? values?.filter(function (entry) {
        return entry === "" ? entry.trim() != "" : entry;
      })
      : [];

  if (vacancyKeys.includes(tabKey) && values.length > 0) {
    if (Object.keys(values[0]).length >= 2) {
      values = values;
    } else {
      values = [];
    }
  }

  if (values && values.length > 0) {
    values = values.filter(function (element) {
      return element !== undefined;
    });


    switch (tabKey) {
      case TAB_KEYS.corousel:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.product:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.service:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.contract:
        return getContractTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.workExperience:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.apprenticeship:
        return getVacancyTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.vacancy:
        return getVacancyTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.whyWorkForUs:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.teamsAndRoles:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.courses:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.businessCard:
        return getTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.news:
        return getNewsTempValues({ tabKey, values, updatedValues, id });
      case TAB_KEYS.press:
        return getNewsTempValues({ tabKey, values, updatedValues, id });
      case contactUSkeys.sales:
        return getContactUsTempValues({ tabKey, values, updatedValues, id });
      case contactUSkeys.hr:
        return getContactUsTempValues({ tabKey, values, updatedValues, id });
      case contactUSkeys.eow:
        return getContactUsTempValues({ tabKey, values, updatedValues, id });
      case contactUSkeys.socialMedia:
        return getContactUsSocialMediaTempValues({ tabKey, values, updatedValues, id });
      case contactUSkeys.address:
        return getContactUsAddressTempValues({ tabKey, values, updatedValues, id });
      case aboutUSkeys.About:
        return getTempValues({ tabKey, values, updatedValues, aboutUsEnum: aboutUSkeys.About, id });
      case aboutUSkeys["Our Story"]:
        return getTempValues({ tabKey, values, updatedValues, aboutUsEnum: aboutUSkeys["Our Story"], id });
      case aboutUSkeys["Our Team"]:
        return getOurTeamTempValues({ tabKey, values, updatedValues, aboutUsEnum: aboutUSkeys["Our Team"], id });
      case aboutUSkeys["Our Client"]:
        return getOurTeamTempValues({ tabKey, values, updatedValues, aboutUsEnum: aboutUSkeys["Our Client"], id });
      case aboutUSkeys.Accreditation:
        return getAccreditationTempValues({ tabKey, values, updatedValues, id });
      default:
        return {};
    }
  } else {
    return {};
  }
};

const getSortedProductData = (modifiedValues, updatedDataIds, tabKey) => {
  var items = {};
  if (modifiedValues && modifiedValues.length > 0) {

    const freshItems = []
    const updatedItems = []

    modifiedValues.forEach((d) => {
      if (d.sectionBlockId) {
        updatedItems.push(d)
      }
      else {
        freshItems.push(d)
      }
    })

    if (freshItems.length > 0) {
      items["newData"] = getFormData(freshItems);
    }
    if (updatedItems.length > 0) {
      items["editedData"] = getFormData(updatedItems);
    }
  }
  return items;
}

const getSortedContractData = (modifiedValues, updatedDataIds, tabKey) => {
  let items = {};

  if (modifiedValues?.length > 0 && tabKey === contract) {
    const freshItems = modifiedValues.filter(d => d.id).length > 0 ? [] : modifiedValues;

    if (freshItems.length > 0) {
      items["newData"] = getContractFormData(freshItems);
    } else {
      const modify = modifiedValues.filter(d => !d.id);
      if (modify.length > 0) {
        items["extraData"] = getContractFormData(modify);
      }

      const edited = modifiedValues.filter((d, i) =>
        updatedDataIds?.includes(i) && d.id
      );
      if (edited.length > 0) {
        items["editedData"] = getContractFormData(edited);
      }
    }
  }
  return items;
};

const getSortedData = (modifiedValues, updatedDataIds, tabKey) => {
  var items = {};
  if (modifiedValues && modifiedValues.length > 0) {
    const freshItems =
      tabKey === "courses" ||
        tabKey === "why-work" ||
        tabKey === "teams-and-roles" ||
        tabKey === "product"
        ? modifiedValues?.filter((ele) => !ele?.sectionBlockId)
        : modifiedValues.filter((d) =>
          vacancyKeys.includes(tabKey) || contract === tabKey
            ? d.id
            : d.sectionBlockId
        ).length > 0
          ? []
          : modifiedValues;
    if (freshItems.length > 0) {
      items["newData"] = vacancyKeys.includes(tabKey)
        ? getVacancyFormData(freshItems)
        : contract === tabKey
          ? getContractFormData(freshItems)
          : getFormData(freshItems);
    } else {
      const modify = modifiedValues.filter(
        (d) =>
          !(vacancyKeys.includes(tabKey) || contract === tabKey
            ? d.id
            : d.sectionBlockId)
      );
      if (modify && modify.length > 0) {
        items["extraData"] = vacancyKeys.includes(tabKey)
          ? getVacancyFormData(modify)
          : contract === tabKey
            ? getContractFormData(modify)
            : getFormData(modify);
      }
      const tempD = [];
      modifiedValues.forEach((d, i) => {
        if (
          updatedDataIds &&
          updatedDataIds.includes(i) &&
          (vacancyKeys.includes(tabKey) || contract === tabKey
            ? d.id
            : d.sectionBlockId)
        ) {
          tempD.push(d);
        }
      });
      if (tempD.length > 0) {
        items["editedData"] = vacancyKeys.includes(tabKey)
          ? getVacancyFormData(tempD)
          : contract === tabKey
            ? getContractFormData(tempD)
            : getFormData(tempD);
      }
    }
  }
  return items;
};

const getFormData = (data) => {
  var formData = new FormData();
  const modifiedData = data.map((d) => {
    if (d.file) {
      formData.append("medias", d.file);
      delete d.file;
    }
    if (d.BrochureFile) {
      formData.append("file", d.BrochureFile);
      delete d.BrochureFile;
    }
    return d;
  });
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });

  formData.append("micrositeDetailsInputs", blob);
  return formData;
};


const formatAboutUs = (data) => {
  var formData = new FormData();
  const mediaMapping = { OUR_TEAM: 'images', OUR_CLIENT: 'images', ACCREDITATIONS_AWARDS: 'awardLogos' }
  const modifiedData = data.map((d) => {
    if (d.blob) {
      formData.append(mediaMapping[d.aboutUsEnum], d.blob);
      delete d.blob;
    }
    return d;
  });
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });
  formData.append("micrositeDetailsInputs", blob);
  return formData;
};

const getVacancyFormData = (data) => {
  var formData = new FormData();
  const modifiedData = data.map((d) => {
    if (d.file) {
      formData.append("files", d.file);
      delete d.file;
    }
    return d;
  });
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });

  formData.append("vacancyDtoList", blob);

  return formData;
};

const getContractFormData = (data) => {
  var formData = new FormData();
  const modifiedData = data.map((d) => {
    if (d.file) {
      formData.append("files", d.file);
      delete d.file;
    }
    return d;
  });
  const json = JSON.stringify(modifiedData);
  const blob = new Blob([json], {
    type: "application/json",
  });

  formData.append("contractsTabInputs", blob);

  return formData;
};

const getTempValues = ({ tabKey, values, updatedValues, aboutUsEnum, id }) => {
  const updatedDataIds = updatedValues?.[tabKey];
  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = {};
        if (d && d.id) {
          temp.sectionBlockId = d.id;
        }
        temp.aboutUsEnum = aboutUsEnum
        temp.title = d.title ? d.title : "";
        if (d && d.assetTitleId) {
          temp.assetTitleId = d.assetTitleId ? d.assetTitleId : "titleID";
        }
        if (d && d.subTitle) {
          temp.subTitle = d.subTitle;
        }
        if (d && d.urlLink) {
          temp.urlLink = d.urlLink;
        }
        temp.description = d.description ? d.description : "";
        if (tabKey !== "businessCard") {
          temp.type = tabKey;
        }
        if (d && d.BrochureFile) {
          temp["BrochureFile"] = d.BrochureFile;
        }
        if (d && d.blob) {
          temp["file"] = d.blob;
        }
        if (d && d.mediaLink) {
          const mediaEx = d.mediaLink;
          if (mediaEx.mediaType === "IMAGE" && mediaEx.mediaProperty) {
            temp.media = {
              mediaProperty: mediaEx.mediaProperty,
              mediaType: "IMAGE",
            };
          } else if (mediaEx.mediaType === "SOCIAL_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SOCIAL_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "VIMEO_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "VIMEO_MEDIA",
              url: mediaEx.url,
            };
          }
          else if (mediaEx.mediaType === "SYNTHESIA_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SYNTHESIA_MEDIA",
              url: mediaEx.url,
            };
          }
        }
        temp.tabConfigId = id
        temp.levelId = d.levelId;
        temp.title = d.title;
        return temp;
      }
    });
    // if (tabKey === 'product')
    // return getSortedProductData(modifiedValues, updatedDataIds, tabKey);
    return getSortedData(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
};

const getOurTeamTempValues = ({ tabKey, values, updatedValues, aboutUsEnum, id }) => {
  const updatedDataIds = updatedValues[tabKey];

  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = {
          "aboutUsEnum": "OUR_TEAM",
          "aboutUsTeamDataInput": {
            "image": {
              "mediaProperty": {
                "id": "",
                "name": "",
                "extension": "",
              },

              "url": "",
              "mediaType": ""
            },
            "bio": "",
          }
        }
        if (d && d.id) {
          temp.sectionBlockId = d.id;
        }
        temp["aboutUsEnum"] = aboutUsEnum
        if (d.blob) {
          temp["blob"] = d.blob
        }

        temp.aboutUsTeamDataInput.bio = d.bio

        if (d.blob) {
          temp.aboutUsTeamDataInput.image = {
            mediaProperty: {
              id: d.awardsLogos?.mediaProperty?.id || "",
              name: d.awardsLogos?.mediaProperty?.name || "",
              extension: d.awardsLogos?.mediaProperty?.extension || "",

            },
            url: d.mediaLink?.url || "",  // 👈 IMPORTANT FIX
            mediaType: d.awardsLogos?.mediaType || d.mediaLink?.mediaType || "",
          };
        } else {
          // alert("else");

          if (d.mediaLink?.mediaType === "IMAGE") {
            temp.aboutUsTeamDataInput.image = d.awardsLogos
          } else {
            temp.aboutUsTeamDataInput.image = {
              url: d.mediaLink?.url || "",  
              mediaType: d.mediaLink?.mediaType || "",
            };
          }

        }

        // temp.aboutUsTeamDataInput.image = d.awardsLogos

        temp.aboutUsTeamDataInput.linkedin = d.linkedin
        temp.aboutUsTeamDataInput.email = d.email
        temp.tabConfigId = id
        temp.description = d.description ? d.description : "";
        temp.title = d.title

        return temp;
      }
    });
    return getSortedDataForAboutUs(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
}

const getAccreditationTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues?.[tabKey];
  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = { ...d };
        if (d && d.id) {
          temp.sectionBlockId = d.id;
        }
        temp.aboutUsEnum = "ACCREDITATIONS_AWARDS"
        if (d.blob) {
          temp["blob"] = d.blob
        }
        if (temp.awardsLogos && !temp.awardsLogos.mediaProperty?.name) {
          delete temp.awardsLogos;
        }
        temp.tabConfigId = id

        return temp;
      }
    });
    return getSortedDataForAboutUs(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
};

const getNewsTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues[tabKey];


  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = {};
        if (d && d.id) {
          temp.sectionBlockId = d.id;
        }
        temp.title = d.title ? d.title : "";
        if (d && d.assetTitleId) {
          temp.assetTitleId = d.assetTitleId ? d.assetTitleId : "titleID";
        }
        if (d && d.urlLink) {
          temp.urlLink = d.urlLink;
        }
        temp.description = d.description ? d.description : "";
        if (tabKey !== "businessCard") {
          temp.type = tabKey;
        }
        if (d && d.blob) {
          temp["file"] = d.blob;
        }
        if (d && d.mediaLink) {
          const mediaEx = d.mediaLink;
          if (mediaEx.mediaType === "IMAGE" && mediaEx.mediaProperty) {
            temp.media = {
              mediaProperty: mediaEx.mediaProperty,
              mediaType: "IMAGE",
            };
          } else if (mediaEx.mediaType === "SOCIAL_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SOCIAL_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "VIMEO_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "VIMEO_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "SYNTHESIA_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SYNTHESIA_MEDIA",
              url: mediaEx.url,
            };
          }
        }
        temp.levelId = d.levelId;
        temp.tabConfigId = id

        return temp;
      }
    });

    return getSortedData(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
};

const getVacancyTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues[tabKey];
  const descriptionItems = [TAB_KEYS.apprenticeship, TAB_KEYS.vacancy];

  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = {};
        if (d && d.id) {
          temp.id = d.id;
        }
        temp.apprenticeshipType = tabKey;
        temp.title = d.title;
        temp.jobTypeEnum = d.jobTypeEnum;
        temp.compensationType = "ANNUALLY";
        temp.compensation = d.compensation;
        temp.closingDate = moment(new Date(d.closingDate)).format("YYYY-MM-DD");
        temp.description = descriptionItems.includes(tabKey)
          ? d.description
          : "description";
        // temp.type = tabKey
        temp.skillIds = d.skillIds;
        temp.urlLink = d.urlLink;
        temp.tabConfigId = id

        if (d && d.blob) {
          temp["file"] = d.blob;
        }
        if (d && d.mediaLink) {
          const mediaEx = d.mediaLink;
          if (mediaEx.mediaType === "IMAGE" && mediaEx.mediaProperty) {
            temp.media = {
              mediaProperty: mediaEx.mediaProperty,
              mediaType: "IMAGE",
            };
          } else if (mediaEx.mediaType === "SOCIAL_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SOCIAL_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "VIMEO_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "VIMEO_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "SYNTHESIA_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SYNTHESIA_MEDIA",
              url: mediaEx.url,
            };
          }
        }
        temp.levelId = d.levelId;
        return temp;
      }
    });

    return getSortedData(modifiedValues, updatedDataIds, tabKey);
  } else {
    return {};
  }
};

const getContractTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues[tabKey];

  if (values && values.length > 0) {
    const modifiedValues = values.map((d, i) => {
      if (d) {
        var temp = {};
        if (d && d.id) {
          temp.id = d.id;
        }
        temp.title = d.title;
        temp.procurementReference = d.procurementReference;
        temp.postalCode = d.postalCode;
        temp.valueOfContract = d.valueOfContract;
        temp.description = d.description;
        if (d.closeTime) {
          temp.closeDate = moment(new Date(d.closeDate)).format("YYYY-MM-DD");
        }
        if (d.startDate) {
          temp.startDate = moment(new Date(d.startDate)).format("YYYY-MM-DD");
        }
        if (d.endDate) {
          temp.endDate = moment(new Date(d.endDate)).format("YYYY-MM-DD");
        }
        if (d.closeTime) {
          temp.closeTime = moment(new Date(d.closeTime)).format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
        }
        temp.contractType = d.contractType;
        temp.webLink = d.webLink;
        temp.email = d.email;
        temp.tabConfigId = id

        if (d && d.blob) {
          temp["file"] = d.blob;
        }
        if (d && d.mediaLink) {
          const mediaEx = d.mediaLink;
          if (mediaEx.mediaType === "IMAGE" && mediaEx.mediaProperty) {
            temp.media = {
              mediaProperty: mediaEx.mediaProperty,
              mediaType: "IMAGE",
            };
          } else if (mediaEx.mediaType === "SOCIAL_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SOCIAL_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "VIMEO_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "VIMEO_MEDIA",
              url: mediaEx.url,
            };
          } else if (mediaEx.mediaType === "SYNTHESIA_MEDIA" && mediaEx.url) {
            temp.media = {
              mediaType: "SYNTHESIA_MEDIA",
              url: mediaEx.url,
            };
          }
        }
        return temp;
      }
    });

    // return getSortedData(modifiedValues, updatedDataIds, tabKey);
    let temp = getSortedContractData(modifiedValues, updatedDataIds, tabKey)
    return temp
  } else {
    return {};
  }
};

const getContactUsTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues?.[tabKey];
  const modifiedValues = values?.map((d, i) => {
    if (d) {
      var temp = {};
      if (d && d.id) {
        temp.sectionBlockId = d.id;
      }
      // values.address.replace(/(\r\n|\n|\r)/g, ' ');
      temp.contactUsId = d.id
      temp.contactUsTypeEnum = tabKey;
      temp.phone = d.phone;
      temp.chatNumber = d.chatNumber;
      temp.websiteLink = d.websiteLink;
      // temp.postalAddress = d?.postalAddress?.replace(/(\r\n|\n|\r)/g, " ") || '';
      temp.email = d.email;
      temp.tabConfigId = id

      return temp;
    }
  });

  return getSortedDataForContactUs(modifiedValues, updatedDataIds, tabKey);
};

const getContactUsSocialMediaTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues[tabKey];

  const modifiedValues = values.map((d, i) => {
    if (d) {
      var temp = {};
      if (d && d.id) {
        temp.sectionBlockId = d.id;
      }
      temp.contactUsId = d.id
      temp.contactUsTypeEnum = tabKey;
      temp.linkedInLink = d.linkedInLink;
      temp.youtubeLink = d.youtubeLink;
      temp.instagramLink = d.instagramLink;
      temp.facebookLink = d.facebookLink;
      temp.tiktokLink = d.tiktokLink;
      temp.twitterLink = d.twitterLink;
      temp.tabConfigId = id

      return temp;
    }
  });

  return getSortedDataForContactUs(modifiedValues, updatedDataIds, tabKey);
};
const getContactUsAddressTempValues = ({ tabKey, values, updatedValues, id }) => {
  const updatedDataIds = updatedValues[tabKey];

  const modifiedValues = values.map((d, i) => {
    if (d) {
      var temp = {};
      if (d && d.id) {
        temp.sectionBlockId = d.id;
      }
      temp.contactUsTypeEnum = tabKey;
      temp.addressInputs = [
        {
          "street": d.street,
          "postalCode": d.postalCode
        }
      ]
      // temp.tabConfigId = id
      return temp;
    }
  });
  return getSortedDataForContactUsAddress({ modifiedValues, updatedDataIds, tabKey, id });
};

const getSortedDataForContactUs = (modifiedValues, updatedDataIds, tabKey) => {
  var items = {};

  if (modifiedValues && modifiedValues.length > 0) {
    const freshItems =
      modifiedValues.filter((d) => d.sectionBlockId).length > 0
        ? []
        : modifiedValues;
    if (freshItems.length > 0) {
      items["newData"] = freshItems;
    } else {
      const modify = modifiedValues.filter((d) => !d.sectionBlockId);
      if (modify && modify.length > 0) {
        items["extraData"] = modify;
      }
      const tempD = [];
      modifiedValues.forEach((d, i) => {
        if (updatedDataIds && updatedDataIds.includes(i) && d.sectionBlockId) {
          tempD.push(d);
        }
      });
      if (tempD.length > 0) {
        items["editedData"] = tempD;
      }
    }
  }
  return items;
};

const getSortedDataForContactUsAddress = ({ modifiedValues, updatedDataIds, tabKey, id }) => {
  var items = { newData: [], editedData: [] };

  modifiedValues.forEach((ele, i) => {
    if (!ele.sectionBlockId) {
      items['newData'].push({
        contactUsTypeEnum: ele.contactUsTypeEnum,
        addressInputs: ele.addressInputs,
        // tabConfigId: id
      })
    }
    if (ele.sectionBlockId && updatedDataIds && updatedDataIds.length > 0 && updatedDataIds.includes(i)) {
      items['editedData'].push({
        contactUsId: ele.sectionBlockId,
        contactUsTypeEnum: ele.contactUsTypeEnum,
        addressInputs: ele.addressInputs,
        // tabConfigId: id
      })
    }
  })

  if (items.newData.length === 0) {
    delete items.newData
  }
  if (items.editedData.length === 0) {
    delete items.editedData
  }
  return items;
};

const getSortedDataForAboutUs = (modifiedValues, updatedDataIds, tabKey) => {
  var items = { newData: [], editedData: [] };

  modifiedValues.forEach((ele, i) => {
    if (!ele.sectionBlockId) {
      items['newData'].push(ele)
    }
    if (ele.sectionBlockId && updatedDataIds && updatedDataIds.length > 0 && updatedDataIds.includes(i)) {
      items['editedData'].push(ele)
    }
  })
  if (items.newData.length === 0) {
    delete items.newData
  }
  if (items.editedData.length === 0) {
    delete items.editedData
  }

  if (items['newData'])
    items['newData'] = formatAboutUs(items['newData'])

  if (items['editedData'])
    items['editedData'] = formatAboutUs(items['editedData'])
  return items;
};